export default __webpack_public_path__ + "static/pspo1logo-c7efd8369b3d90968b64ffed68ac2e75.png";